<template>
  <section id="dashboard-ecommerce">
    <b-row>
      <b-col>
        <h4>{{ $t('Running') }}</h4>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col
        xl="2"
        lg="3"
        cols="6"
      >
        <DashboardGenericCard
          :title="$t('Ongoing mentoring')"
          icon="UsersIcon"
          color="#eb672f"
          :total="currentMentorships"
        />
      </b-col>
      <b-col
        xl="2"
        lg="3"
        cols="6"
      >
        <DashboardGenericCard
          :title="$t('Ongoing coaching')"
          icon="UsersIcon"
          color="#6CAFBC"
          :total="currentCoachings"
        />
      </b-col>
      <b-col
        xl="8"
        lg="6"
      >
        <DashboardPendingRequestsCard :data="pendingRequests" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h4>{{ $t("Mentoships") }}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        xl="2"
        cols="6"
      >
        <DashboardGenericCard
          :title="$t('Total mentorings')"
          icon="UsersIcon"
          color="#eb672f"
          :total="totalMentorships"
        />
      </b-col>
      <b-col
        xl="2"
        cols="6"
      >
        <DashboardGenericCard
          :title="$t('Total coachings')"
          icon="UsersIcon"
          color="#6CAFBC"
          :total="totalCoachings"
        />
      </b-col>
      <b-col
        xl="8"
      >
        <b-row class="match-height">
          <b-col
            xl="6"
            md="12"
          >
            <DashboardDoughnutChart
              v-if="mentoringChartDataReady"
              :title="$t('Mentoring duration')"
              :data="mentoringChartData.mentoringDuration"
            />
          </b-col>
          <b-col
            xl="6"
            md="12"
          >
            <DashboardDoughnutChart
              v-if="mentoringChartDataReady"
              :title="$t('Mentoring type')"
              :data="mentoringChartData.mentoringType"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        xl="6"
        cols="12"
      >
        <DashboardMultipleBarChart
          v-if="newMentorshipsChartRecordsReady"
          :title="$t('New mentorships')"
          :data="newMentorshipsChartRecords"
          y-step="10"
        />
      </b-col>
      <b-col
        xl="6"
        cols="12"
      >
        <DashboardMultipleBarChart
          v-if="newCoachingsChartRecordsReady"
          :title="$t('New coachings')"
          :data="newCoachingsChartRecords"
          y-step="5"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h4> {{ $t('Mentors') }}</h4>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col
        xl="6"
        md="12"
      >
        <DashboardBarChart
          v-if="mentorsChartRecordsReady"
          :title="$t('Records')"
          :data="mentorsChartRecords"
        />
      </b-col>
      <b-col
        xl="6"
        sm="12"
      >
        <b-row class="match-height">
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('All')"
              icon="UserIcon"
              color="#7F2E6A"
              :total="totalMentors"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('Active mentorships')"
              icon="UserCheckIcon"
              color="#6CAFBC"
              :total="curentMentors"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('Inactive (plural)')"
              icon="UserXIcon"
              color="#d46878"
              :total="inactiveMentors"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h4> {{ $t('Mentees') }}</h4>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col
        xl="6"
        sm="12"
      >
        <DashboardBarChart
          v-if="menteesChartRecordsReady"
          :title="$t('Records')"
          :data="menteesChartRecords"
        />
      </b-col>
      <b-col
        xl="6"
        sm="12"
      >
        <b-row class="match-height">
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('All')"
              icon="UserIcon"
              color="#7F2E6A"
              :total="totalMentees"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('Active mentorships')"
              icon="UserCheckIcon"
              color="#6CAFBC"
              :total="menteesWithOngoingMentorship"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('Completed mentoring')"
              icon="CheckCircleIcon"
              color="#5AB78E"
              :total="menteesWithCompletedMentorship"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('To be paid')"
              icon="CreditCardIcon"
              color="#eb672f"
              :total="menteesAwaitingPayment"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('With open package')"
              icon="PackageIcon"
              color="#eb672f"
              :total="menteesWithOpenPackage"
            />
          </b-col>
          <b-col cols="4">
            <DashboardGenericCard
              :title="$t('Without package')"
              icon="XIcon"
              color="#d46878"
              :total="menteesWithoutPackage"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { useDashboardRepository } from '@mentoring-platform/composables'
import {
  BCol, BRow,
} from 'bootstrap-vue'

import DashboardBarChart from '../../components/blocks/Dashboard/DashboardBarChart.vue'
import DashboardMultipleBarChart from '../../components/blocks/Dashboard/DashboardMultipleBarChart.vue'
import DashboardGenericCard from '../../components/blocks/Dashboard/DashboardGenericCard.vue'
import DashboardPendingRequestsCard from '../../components/blocks/Dashboard/DashboardPendingRequestsCard.vue'
import DashboardDoughnutChart from '../../components/blocks/Dashboard/DashboardDoughnutChart.vue'

export default {
  components: {
    BCol,
    BRow,

    DashboardBarChart,
    DashboardDoughnutChart,
    DashboardGenericCard,
    DashboardMultipleBarChart,
    DashboardPendingRequestsCard,
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {
    currentMentorships() {
      return this.dashboard?.subscriptions?.current_mentorships?.total?.toString() || '-'
    },
    currentCoachings() {
      return this.dashboard?.subscriptions?.current_coachings?.total?.toString() || '-'
    },
    totalMentorships() {
      return this.dashboard?.subscriptions?.mentorships?.total?.toString() || '-'
    },
    totalCoachings() {
      return this.dashboard?.subscriptions?.coachings?.total?.toString() || '-'
    },
    totalMentors() {
      return this.dashboard?.mentors?.total?.toString() || '-'
    },
    curentMentors() {
      return this.dashboard?.mentors?.currently_mentoring_or_coaching?.toString() || '-'
    },
    inactiveMentors() {
      return this.dashboard?.mentors?.inactive?.toString() || '-'
    },
    totalMentees() {
      return this.dashboard?.mentees?.total?.toString() || '-'
    },
    menteesAwaitingPayment() {
      return this.dashboard?.mentees?.with_package_awaiting_payment?.toString() || '-'
    },
    menteesWithOpenPackage() {
      return this.dashboard?.mentees?.with_open_package?.toString() || '-'
    },
    menteesWithoutPackage() {
      return this.dashboard?.mentees?.without_package?.toString() || '-'
    },
    menteesWithCompletedMentorship() {
      return this.dashboard?.mentees?.with_completed_mentorship?.toString() || '-'
    },
    menteesWithOngoingMentorship() {
      return this.dashboard?.mentees?.with_ongoing_mentorship?.toString() || '-'
    },
    pendingRequests() {
      return [
        {
          icon: 'ClipboardIcon',
          color: '#5AB78E',
          title: this.dashboard?.pending?.pending_mentor_applications || '-',
          subtitle: 'Mentor requests',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'UserPlusIcon',
          color: '#7F2E6A',
          title: this.dashboard?.pending?.pending_mentorship_requests || '-',
          subtitle: 'Mentoring requests',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'RepeatIcon',
          color: '#6CAFBC',
          title: this.dashboard?.pending?.pending_edit_requests || '-',
          subtitle: 'Edit profile requests',
          customClass: 'mb-2 mb-sm-0',
        },
      ]
    },
    mentoringChartData() {
      return {
        mentoringDuration: [
          {
            title: this.$t('3-month'), icon: 'CalendarIcon', color: '#eb672f', value: this.dashboard?.subscriptions?.mentorships?.three_month || 0, percent: ((this.dashboard?.subscriptions?.mentorships?.three_month / this.dashboard?.subscriptions?.mentorships?.total) * 100).toFixed(2) || 50,
          },
          {
            title: this.$t('6-month'), icon: 'CalendarIcon', color: '#7F2E6A', value: this.dashboard?.subscriptions?.mentorships?.six_month || 0, percent: ((this.dashboard?.subscriptions?.mentorships?.six_month / this.dashboard?.subscriptions?.mentorships?.total) * 100).toFixed(2) || 50,
          },
        ],
        mentoringType: [
          {
            title: this.$t('with scholarship'), icon: 'HeartIcon', color: '#d46878', value: this.dashboard?.subscriptions?.mentorships?.scholarship || 0, percent: ((this.dashboard?.subscriptions?.mentorships?.scholarship / this.dashboard?.subscriptions?.mentorships?.total) * 100).toFixed(2) || 50,
          },
          {
            title: this.$t('paid'), icon: 'CreditCardIcon', color: '#6CAFBC', value: this.dashboard?.subscriptions?.mentorships?.paid || 0, percent: ((this.dashboard?.subscriptions?.mentorships?.paid / this.dashboard?.subscriptions?.mentorships?.total) * 100).toFixed(2) || 50,
          },
        ],
      }
    },
    mentoringChartDataReady() {
      return this.dashboard?.subscriptions?.mentorships?.three_month
        && this.dashboard?.subscriptions?.mentorships?.six_month
        && this.dashboard?.subscriptions?.mentorships?.scholarship
        && this.dashboard?.subscriptions?.mentorships?.paid
    },
    mentorsChartRecords() {
      return {
        monthly: this.dashboard?.mentors?.daily_signups || [],
        yearly: this.dashboard?.mentors?.monthly_signups || [],
      }
    },
    mentorsChartRecordsReady() {
      return this.dashboard?.mentors?.daily_signups
        && this.dashboard?.mentors?.monthly_signups
    },
    menteesChartRecords() {
      return {
        monthly: this.dashboard?.mentees?.daily_signups || [],
        yearly: this.dashboard?.mentees?.monthly_signups || [],
      }
    },
    menteesChartRecordsReady() {
      return this.dashboard?.mentees?.daily_signups
        && this.dashboard?.mentees?.monthly_signups
    },
    newMentorshipsChartRecords() {
      return {
        monthly: {
          paid: this.dashboard?.subscriptions?.mentorships?.dailyPaid || [],
          scholarship: this.dashboard?.subscriptions?.mentorships?.dailyScholarship || [],

        },
        yearly: {
          paid: this.dashboard?.subscriptions?.mentorships?.monthlyPaid || [],
          scholarship: this.dashboard?.subscriptions?.mentorships?.monthlyScholarship || [],
        },
      }
    },
    newMentorshipsChartRecordsReady() {
      return this.dashboard?.subscriptions?.mentorships?.dailyPaid
        && this.dashboard?.subscriptions?.mentorships?.dailyScholarship
        && this.dashboard?.subscriptions?.mentorships?.monthlyPaid
        && this.dashboard?.subscriptions?.mentorships?.monthlyScholarship
    },
    newCoachingsChartRecords() {
      return {
        monthly: {
          paid: this.dashboard?.subscriptions?.coachings?.dailyPaid || [],
          scholarship: this.dashboard?.subscriptions?.coachings?.dailyScholarship || [],
        },
        yearly: {
          paid: this.dashboard?.subscriptions?.coachings?.monthlyPaid || [],
          scholarship: this.dashboard?.subscriptions?.coachings?.monthlyScholarship || [],
        },
      }
    },
    newCoachingsChartRecordsReady() {
      return this.dashboard?.subscriptions?.coachings?.dailyPaid
        && this.dashboard?.subscriptions?.coachings?.dailyScholarship
        && this.dashboard?.subscriptions?.coachings?.monthlyPaid
        && this.dashboard?.subscriptions?.coachings?.monthlyScholarship
    },
  },
  setup() {
    const { getDashboard, dashboard } = useDashboardRepository()
    getDashboard()

    return {
      getDashboard,
      dashboard,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';

h4 {
  font-size: 22px;
  margin-bottom: 1rem;
}
</style>
